<template>
  <v-dialog v-model="showDialog" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">Modificar contraseña y/o Email</v-card-title>
      <v-card-text>
        <strong>Importante:</strong> {{ mensaje }}
        <p class="mt-2 mb-0"><strong>¿Quieres continuar de todos modos?</strong></p>
      </v-card-text>
      <v-card-actions>
        <v-row justify="space-around" class="mx-0 mb-2">
          <v-btn color="error" text transition="fade-transition" @click.native="cancelar">Cancelar</v-btn>
          <v-btn color="secondary" text transition="fade-transition" @click.native="continuar">Continuar</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props : {
    mensaje: {
      type: String,
      default: 'Al presionar el botón Continuar se redireccionará a otro sitio cerrando la sesión actual.'
    },
    jwt: {
      type: Boolean,
      default: false,
    }
  },
  data: function() {
    return {};
  },
  computed: {
    showDialog : function () {
      return this.$store.state.profile;
    }
  },
  methods: {
    cancelar : function () {
      this.$store.commit('setProfile', false);
    },
    continuar: async function () {
      let status = 200;
      if (this.jwt) {
        localStorage.removeItem('token');
      } else {
        ({ status } = await fetch('/logout', {
          credentials: 'include',
          redirect: 'manual',
          headers: {
            'Accept': 'application/json',
          },
        }));
      }
      if (status == 200) {
        this.$store.commit('setProfile', false);
        window.onbeforeunload = null;
        window.location = window.DATA.profileUrl;
      }
    }
  }
};
</script>
